module.exports = __webpack_public_path__ + "static/shoe-gray-dd3e96ad60ecd9d35f39c54d9598b291.png";